import React from 'react';
import styled from 'styled-components';
import nl2br from 'react-nl2br';
import { camelCase } from 'change-case';
import i18n from '@/settings/i18n';
import { Notice } from '@/types/notice';

export type Props = {
  notices: Notice[];
};

export const Presentation: React.FC<Props> = (props) => {
  const content_lang_key = `content_${i18n.language}`;
  return props.notices.length ? (
    <Wrapper>
      {props.notices.map((notice) => (
        <p key={notice[camelCase(content_lang_key)]}>
          {nl2br(notice[camelCase(content_lang_key)])}
        </p>
      ))}
    </Wrapper>
  ) : (
    <></>
  );
};

export const Wrapper = styled.div`
  padding: 16px;
  text-align: center;
  color: #db3333;
  font-size: 16px;
`;
